import { render, staticRenderFns } from "./ProductIframe.vue?vue&type=template&id=b9ac4c66&scoped=true&"
import script from "./ProductIframe.vue?vue&type=script&lang=js&"
export * from "./ProductIframe.vue?vue&type=script&lang=js&"
import style0 from "./ProductIframe.vue?vue&type=style&index=0&id=b9ac4c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ac4c66",
  null
  
)

export default component.exports